<template>
  <main class="mt2 mb4">
    <div class="clearfix">
      <button @click="addNew()" id="pageForm" class="p2 outlined-action-button flex justify-center items-center gibson h5 not-rounded">
        <span>Tilføj ny side</span>
        <span class="mx2">
          <i class="el-icon-right"></i>
        </span>
      </button>
      <b-collapse id="collapse1" v-model="showCollapse" class="my4">
        <form @submit.stop.prevent="website_page" id="formSubmit" class="xs-col-12 sm-col-12 md-col-6 lg-col-6">
          <div class="clearfix mb2">
            <b-form-group label-for="" class="h6 darkblue gibson line-height-1 mb1">
              <p class="h6 darkblue semi-bold">Titel</p>
              <b-form-input id="title" v-model="Page.title" class="not-rounded border-none p2 lightgrey-background gibson darkblue h5" required></b-form-input>
            </b-form-group>
          </div>
          <div class="clearfix mb2">
            <b-form-group label-for="" class="h6 darkblue gibson line-height-1 mb1 flex justify-start items-center">
              <p class="h6 darkblue semi-bold">Status</p>
              <div class="flex justify-start items-center p2 lightgrey-background">
                <span class="mr1"><input type="checkbox" v-model="Page.active"></span>
                <template>
                  <span v-if="Page.active">Aktiv</span>
                  <span v-else>Ikke aktiv</span>
                </template>
              </div>
            </b-form-group>
          </div>
          <div class="clearfix mb2">
            <p class="h6 darkblue semi-bold">Notat</p>
            <wysiwyg placeholder="Skriv til support" required v-model="Page.note" />
          </div>
          <div class="clearfix mb2">
            <b-form-group class="h6 darkblue gibson line-height-1 mb1">
              <p class="h6 darkblue semi-bold">Siden som</p>
              <div class="lightgrey-background p2">
                <select :value="Page.page" v-model="Page.page" id="method" class="not-rounded border-none lightgrey-background gibson darkblue line-height-1 h6 m0 p0 regular col-12">
                  <option value=""></option>
                  <option value="1">Om os</option>
                  <option value="2">Tjenester</option>
                  <option value="3">Projekt</option>
                  <option value="4">Kontakt</option>
                </select>
              </div>
            </b-form-group>
          </div>
          <div class="clearfix mb2">
            <div v-if="!Page.image">
              <b-form-group class="h6 darkblue gibson line-height-1 mb1">
                <p class="h6 darkblue semi-bold">Billede</p>
                <b-form-file class="flex justify-between p2 py3 items-center lightgrey-background" no-drop @change="onFileChange" placeholder="Vælg fil"></b-form-file>
              </b-form-group>
            </div>
            <div v-else>
              <div class="clearfix">
                <div class="col-12 px0">
                  <img class="fit block" :src="Page.image" />
                  <b-btn variant="danger" class="rounded" size="sm" @click="removeImage">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm9 12c0 1.94-.624 3.735-1.672 5.207l-12.535-12.535c1.472-1.048 3.267-1.672 5.207-1.672 4.962 0 9 4.038 9 9zm-18 0c0-1.94.624-3.735 1.672-5.207l12.534 12.534c-1.471 1.049-3.266 1.673-5.206 1.673-4.962 0-9-4.038-9-9z"/></svg>
                  </b-btn>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 px0 flex justify-between items-center">
            <button type="button" v-b-toggle.collapse1 class="not-rounded outlined-disabled-button p2 flex justify-center items-center gibson h5">
              <span class="pr2"><i class="el-icon-back"></i></span>
              <span>Luk</span>
            </button>
            <button type="submit" v-if="!Page.id" class="not-rounded action-button p2 flex justify-center items-center gibson h5 regular" variant="success" size="lg" :disabled="isLoadingReview">
              <span>
                Offentliggør
              </span>
              <span class="pl2"><i class="el-icon-right"></i></span>
            </button>
            <button type="submit" v-if="Page.id" class="not-rounded outlined-action-button p2 flex justify-center items-center gibson h5" :disabled="isLoadingReview">
              <i class="el-icon-success mr-2"></i>Opdater '{{Page.title}}'
            </button>
          </div>
        </form>
      </b-collapse>
    </div>
    <div class="clearfix">
      <table class="table is-fullwidth is-striped">
        <thead>
          <tr>
            <th><span class="h6 darkblue gibson line-height-1">Titel</span></th>
            <th><span class="h6 darkblue gibson line-height-1">Siden som</span></th>
            <th><span class="h6 darkblue gibson line-height-1">Status</span></th>
            <th><span class="h6 darkblue gibson line-height-1"></span></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(post, index) in filteredPosts" :key="index">
            <td class="post-title-cell">
              <span class="darkblue gibson h6 regular line-height-1 m0 p0">{{post.title}}</span>
            </td>
            <td class="post-category-cell">
              <span class="darkblue gibson h6 regular line-height-1 m0 p0">{{pageType(post.page)}}</span>
            </td>
            <template>
              <td v-if="post.active == true" class="post-author-cell">
                <span class="green gibson h6 line-height-1 m0 p0">Aktiv</span>
              </td>
              <td v-else>
                <span class="red gibson h6 line-height-1 m0 p0">Ikke aktiv</span>
              </td>
            </template>
            <td class="post-author-cell">
              <b-button size="sm" class="not-rounded border-none" @click="editPage(post)"  variant="outline-success">
                <span class="far fa-edit"></span>
              </b-button>
              <b-button size="sm" class="not-rounded border-none" @click="sletPage(post)" variant="outline-danger">
                <span class="far fa-trash-alt"></span>
              </b-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <loading :show="show" :label="label" :overlay="overlay"></loading>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </main>
</template>
<script>
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
export default {
  name: 'websitecontents',
  components: {
    loading,
    Simplert
  },
  props: ['filteredPosts'],
  data () {
    return {
      showModal: false,
      showCollapse: false,
      show: false,
      label: 'Vent venligst...',
      picked: '',
      overlay: true,
      isLoadingReview: false,
      Cpage: '',
      Page: {
        id: '',
        title: '',
        note: '',
        active: true,
        image: '',
        page: ''
      },
      header: '',
      kind: '',
      post: '',
      sortKey: 'tittle'
    }
  },
  methods: {
    postDate (epoch) {
      if (!epoch) return // if no time return nothing
      return this.moment(epoch).format('MM/DD/YY | hh:mm')
    },
    pageType (type) {
      if (type === '1') {
        return 'Om os'
      } else if (type === '2') {
        return 'Tjenester'
      } else if (type === '3') {
        return 'Projekt'
      } else if (type === '4') {
        return 'Kontakt'
      }
    },
    editPage (page) {
      this.Cpage = page
      this.showCollapse = true
      this.Page = this.Cpage
      $('html, body').animate({
        scrollTop: 0
      }, 600)
    },
    sletPage (item) {
      let confirmFn = function () {
        this.$parent.sletPage_remove(item)
      }
      let obj = {
        title: 'Bekræft',
        message: 'Er du sikker på at du vil slette denne side?',
        useConfirmBtn: true,
        onConfirm: confirmFn,
        customConfirmBtnText: 'Bekræft',
        customConfirmBtnClass: 'simplert__confirm bg-success',
        customCloseBtnClass: 'simplert__close bg-secondary',
        customCloseBtnText: 'Luk',
        showXclose: true
      }
      this.$refs.simplert.openSimplert(obj)
    },
    emptyPage () {
      this.Page.id = ''
      this.Page.title = ''
      this.Page.note = ''
      this.Page.active = true
      this.Page.image = ''
      this.Page.page = ''
    },
    addNew () {
      this.emptyPage()
      this.showCollapse = true
      this.$emit('Reload')
    },
    sletPage_remove (item) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'website_del', salesPerson: this.salesPerson, levid: this.haaId, item: item.id}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              this.emptyPage()
              this.$emit('Reload')
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    website_page () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'website_page', salesPerson: this.salesPerson, levid: this.haaId, Page: JSON.stringify(this.Page)}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
              this.emptyPage()
              this.$emit('Reload')
              this.showCollapse = false
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.createImage(files[0])
    },
    createImage (file) {
      var reader = new FileReader()
      var vm = this
      reader.onload = (e) => {
        vm.Page.image = e.target.result
      }
      reader.readAsDataURL(file)
    },
    removeImage: function (e) {
      this.Page.image = ''
    }
  }
}
</script>
<style>
.loader-wrapper {
  left: 50%;
  margin-left: -100px;
  top: 50%;
  margin-top: -50px;
}
.b-form-file > label {
  padding: .5rem 1rem;
  color: white;
  background-color: rgba(0, 54, 69, 1.0);
  margin: 1rem 0;
}
/* #collapse1 > div > .card-body {
} */
.tab-content {
  border:0;
}
.col-form-label {
  font-weight: 600;
}
.card-header {
  background: none;
}
.tab-content .tab-pane {
  padding-left: 0;
  padding-right: 0;
}
</style>



// WEBPACK FOOTER //
// websitecontents.vue?1120a2d4